/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationDetailsBatchResponse {
    getFixupPrototypeFunction() { return RecommendationDetailsBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<RecommendationDetailsBatchResponse>): RecommendationDetailsBatchResponse {
        let obj = Object.assign(new RecommendationDetailsBatchResponse(), model);
        RecommendationDetailsBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationDetailsBatchResponse>): RecommendationDetailsBatchResponse {
        if (!model) return null;
        return RecommendationDetailsBatchResponse.newInstance(<RecommendationDetailsBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationDetailsBatchResponse) {
        if (!obj) return;

        models.RecommendationDetailsBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationDetailsBatchResponse): boolean {
        Object.setPrototypeOf(obj, RecommendationDetailsBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.RecommendationDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.RecommendationDetails; };

}
